import { Box, Card, CardContent, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import LeaderboardRow from "./LeaderboardRow.tsx";

const Leaderboard = ({leaderboardRows, setSelectedTeamId}) => {
    return (
        <Card key="leaderboard" sx={{
            ml: 1,
            mr: 2,
            mt: 1,
            mb: 1,
            width: "50%",
            background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.95) 0%, rgba(101, 67, 33, 0.92) 100%)',
            backdropFilter: 'blur(10px)',
            border: '0.2rem solid rgba(218, 165, 32, 0.7)',
            borderRadius: '1rem',
            boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.5), 0 0 1rem rgba(218, 165, 32, 0.4)',
        }} variant="outlined">
            <CardContent>
                <Box>
                    <Typography variant="h6" sx={{
                        fontFamily: "'Cinzel', serif",
                        color: '#FFD700',
                        fontWeight: 700,
                        textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                        mb: 2,
                    }}>
                        Leaderboard
                    </Typography>
                    <Box pt={1}>
                        <Table>
                            <TableBody>
                                <TableRow sx={{
                                    background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.4) 0%, rgba(101, 67, 33, 0.3) 100%)',
                                    borderBottom: '0.15rem solid rgba(218, 165, 32, 0.6)',
                                }}>
                                    <TableCell sx={{
                                        fontWeight: 700,
                                        p: 1,
                                        fontFamily: "'Cinzel', serif",
                                        color: '#FFD700',
                                        fontSize: '0.95rem',
                                        textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                                        borderBottom: 'none',
                                    }}>
                                        Team Name
                                    </TableCell>
                                    <TableCell sx={{
                                        fontWeight: 700,
                                        p: 1,
                                        fontFamily: "'Cinzel', serif",
                                        color: '#FFD700',
                                        fontSize: '0.95rem',
                                        textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                                        borderBottom: 'none',
                                    }}>
                                        Total Credits
                                    </TableCell>
                                    <TableCell sx={{
                                        fontWeight: 700,
                                        p: 1,
                                        fontFamily: "'Cinzel', serif",
                                        color: '#FFD700',
                                        fontSize: '0.95rem',
                                        textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                                        borderBottom: 'none',
                                    }}>
                                        Shumas Score
                                    </TableCell>
                                    <TableCell sx={{
                                        fontWeight: 700,
                                        p: 1,
                                        fontFamily: "'Cinzel', serif",
                                        color: '#FFD700',
                                        fontSize: '0.95rem',
                                        textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                                        borderBottom: 'none',
                                    }}>
                                        Action
                                    </TableCell>
                                </TableRow>
                                {leaderboardRows.map((row, index) => (
                                    <LeaderboardRow key={index} teamRow={row} setSelectedTeamId = {setSelectedTeamId} />
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}

export default Leaderboard;